import React from 'react';
import Header from './Header';
import Hero from './Hero';
import About from './About';
// import CourseTracks from './CourseTracks';
import Accreditation from './Accreditation';
import Enumeration from './Enumeration';
import Executives from './Executives';
import Contact from './Contact';
import Footer from './Footer';
import Organogram from './Organogram';
import HeroSlider from './HeroSlider';
import OrganogramDiagram from './OrganogramDiagram';

const Main = () => {
  return (
    <>
      <Header />
      <Hero />
      {/* <HeroSlider /> */}
      <About />
      {/* <CourseTracks /> */}
      <Accreditation />
      {/* <Enumeration /> */}
      <Organogram/>
      {/* <OrganogramDiagram/> */}
      <Executives />
      {/* <Contact /> */}
      <Footer />
    </>
  );
};

export default Main;
